<template>
    <div class="form-group">
        <label v-if="label != ''">{{label}}</label>
        <div class="input-group">

            <datepicker v-model="from" type="text" class="form-control" v-bind:class="[ (from != '') ? 'border-right-0' : '']" placeholder="From"/>
            <button  v-if="from != ''" class="btn bg-white border border-left-0 rounded-0 input-group-text" type="button" @click="clearFrom"><i class="icon-cross"></i></button>

            <datepicker v-model="to" type="text" class="form-control" v-bind:class="[ (to != '') ? 'border-right-0' : '']" placeholder="To"/>
            <button  v-if="to != ''" class="btn bg-white border border-left-0 rounded-0 input-group-text" type="button" @click="clearTo"><i class="icon-cross"></i></button>

            <div class="input-group-append">
                <datepickerrange v-model="data" />
            </div>
        </div>
    </div>
</template>

<script>

import datepicker from './datepicker.vue'
import datepickerrange from './datepickerrange.vue'

export default {
    components: {
        datepicker,
        datepickerrange
    },
    props: {
        value: {
            default: function() { return {
                from : '',
                to : ''
            }}
        },
        label :{
            type: String,
            default: ""
        },
        isLoading : {
            type: Boolean,
            default: false
        },
        hideSearchBox: {
            type: Boolean,
            default: false
        },
        allowClear : {
            type: Boolean,
            default: true
        }
    },
    watch: {
        isLoading (value, old) {

        },
        value (value, old) {

        },
    },
    mounted () {
        this.initialize();
    },
    computed: {
        from : {
            get() {
                return this.value.from;
            },
            set(value) {
                this.value.from = value;
                this.rangechanged();
            }
        },
        to : {
            get() {
                return this.value.to;
            },
            set(value) {
                this.value.to = value;
                this.rangechanged();
            }
        },
        data: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            }
        }
    },
    methods : {
        initialize(){
        },
        rangechanged : function(){
            this.$emit('input', this.value)
        },
        clearFrom : function(){
            this.from = ''
        },
        clearTo : function(){
            this.to = ''
        }
    }
};
</script>